/* ======================================================================== */
/* 13. grid */
/* ======================================================================== */
/* ======================================================================== */
/* Masonry Grid */
/* ======================================================================== */
var Grid = function ($scope) {

	var
		$grid = $('.js-grid'),
		$filter = $('.js-filter'),
		$filterItems = $filter.find('.js-filter__item'),
		$target = $scope.find('.js-grid[data-os-animation]'),
		$items = $target.find('.grid__item'),
		$heading = $target.find('.grid__item-header h3'),
		$meta = $target.find('.grid__item-header .post-meta li'),
		splitHeading = splitLines($heading),
		splitMeta = splitLines($meta),
		circle = new Circle();

	if (!$grid.length) {
		return;
	}

	createGrid();
	prepare();
	animate();

	function createGrid() {

		var $links = $grid.find('.grid__item-link');

		var
			masonryGrid = $grid.masonry({
				itemSelector: '.js-grid__item',
				columnWidth: '.js-grid__sizer',
				horizontalOrder: true
			})

		$grid.imagesLoaded({
			background: true
		}, function () {
			masonryGrid.masonry('layout');
		});

		if ($links.length) {

			$links.each(function () {
				var $el = $(this);
				circle.animate($el);
			})

		}

		if ($filter.length) {

			$grid.isotope();

			$filterItems.on('click', function (e) {

				e.preventDefault();

				var
					$el = $(this),
					filterBy = $el.data('filter');

				$filterItems.removeClass('filter__item_active');
				$el.addClass('filter__item_active');

				masonryGrid.isotope({
					itemSelector: '.js-grid__item',
					columnWidth: '.js-grid__sizer',
					horizontalOrder: true,
					filter: filterBy
				});

			});

		}

	}

	function prepare() {

		if (!$target.length) {
			return;
		}

		setLines(splitHeading.words);
		setLines(splitMeta.words);

		TweenMax.set($items, {
			visibility: 'visible',
			opacity: 0,
			y: '50px',
			scaleY: 1.2,
			transformOrigin: 'top center'
		});

	}

	function animate() {

		if (!$target.length) {
			return;
		}

		var
			colsDesktop = parseInt($target.data('grid-columns'), 10),
			colsTablet = parseInt($target.data('grid-columns-tablet'), 10),
			colsMobile = parseInt($target.data('grid-columns-mobile'), 10),
			lg = elementorFrontend.config.breakpoints.lg - 1 || 1024,
			md = elementorFrontend.config.breakpoints.md - 1 || 767,
			cols = colsDesktop;

		if (Modernizr.mq('(max-width: ' + lg + 'px)')) {
			cols = colsTablet;
		}

		if (Modernizr.mq('(max-width: ' + md + 'px)')) {
			cols = colsMobile;
		}

		for (var index = 0; index < $items.length; index = index + cols) {

			var
				$array = $items.slice(index, index + cols),
				elHeading = $array.find(splitHeading.words),
				elMeta = $array.find(splitMeta.words),
				tl = new TimelineMax();

			tl
				.staggerTo($array, 0.9, {
					opacity: 1,
					y: '0px',
					scaleY: 1,
				}, 0.15)
				.add(animateLines(elHeading), '0.6')
				.add(animateLines(elMeta), '0.9');

			createOSScene($array[0], tl, false, true);

		}

	}

}
